// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DynProperty } from '@shared/commons/DynProperty';
import { ErrorInformationStorage } from '@shared/commons/ErrorInformationStorage';
import { Resources } from '@shared/localizations/Resources';
import { BaseItem, ColumnData } from '../BaseItem';
import { ColumnParams } from '../ColumnParams';
import { TableTotalsVisibility } from '../TableTotalsVisibility';
import { QTAlignment } from '../../elements/QuickTable/QuickTableColumn';
export class NewVerticalPanelTableItem extends BaseItem {
    constructor(id, rowKey, RowValue, GroupStr, SortIndex, sessionSettings) {
        super(sessionSettings);
        this.DynPropertyControltype = DynProperty.STRING;
        this.GroupIndex = null;
        this._itemId = this.itemId;
        this.itemId = id;
        this.RowKey = rowKey;
        this.RowKey_Localized = rowKey;
        this.RowValue = RowValue;
        this.GroupStr = GroupStr;
        this.SortIndex = SortIndex;
    }
    get ItemId() {
        return this._itemId;
    }
    set ItemId(id) {
        this._itemId = id;
    }
    ColumnCount() {
        return NewVerticalPanelTableItem.columnsParams.length;
    }
    getColumnData(column) {
        const o = this.getColumnValue(column);
        return new ColumnData(o, o ? o.toString() : '');
    }
    getColumnValue(column) {
        try {
            switch (column) {
                case 0:
                    return this.RowKey_Localized;
                case 1:
                    return this.RowValue;
                case 2:
                    return this.GroupStr; // GroupStr;
                case 3:
                    return this.SortIndex;
                default:
                    return '';
            }
        }
        catch (ex) {
            ErrorInformationStorage.GetException(ex);
            console.log(ex);
            return '';
        }
    }
    GetColumnParams(column) {
        const result = NewVerticalPanelTableItem.columnsParams[column];
        result.Hidden = result.DefaultHidden || Resources.isHidden(result.HeaderKey) || column === 2 || column === 3;
        return result;
    }
}
/// <summary>
/// Здесь хранятся настройки колонок (один экземпляр на класс)
/// </summary>
NewVerticalPanelTableItem.columnsParams = [
    new ColumnParams('AccountDetailesPanel.quickTable.Name', 200, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('AccountDetailesPanel.quickTable.Value', 300, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('Group', 80, QTAlignment.Left, TableTotalsVisibility.None, false, true),
    new ColumnParams('SortIndex', 80, QTAlignment.Left, TableTotalsVisibility.None, false, true)
];
